import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    Card_type: "",
    hasShopName: false,
    hasWifi: false,
    CardQrcodeCount: 1,
    ossURL: "//cdn.52cxmj.xyz/cdn/cxmj-qrcodehandler-front",
  },
  mutations: {
    SET_CARD_TYPE(state, value) {
      state.Card_type = value.Card_type;
      state.hasShopName = value.hasShopName;
      state.hasWifi = value.hasWifi;
      state.CardQrcodeCount = value.CardQrcodeCount;
    },
  },
  actions: {
    set_Card_type({ commit }, value) {
      let Card_type = value;
      let hasShopName;
      let hasWifi;
      let CardQrcodeCount;

      let setAttribute = (
        attr_Card_type,
        attr_hasShopName,
        attr_hasWifi,
        attr_CardQrcodeCount
      ) => {
        Card_type = attr_Card_type;
        hasShopName = attr_hasShopName;
        hasWifi = attr_hasWifi;
        CardQrcodeCount = attr_CardQrcodeCount;
      };

      switch (Card_type) {
        case "1-1":
          setAttribute("1-1", true, false, 1);
          break;
        case "2-1":
          setAttribute("2-1", false, false, 2);
          break;
        case "2-1-1":
          setAttribute("2-1-1", false, false, 2);
          break;
        case "2-2":
          setAttribute("2-2", false, false, 2);
          break;
        case "2-2-1":
          setAttribute("2-2-1", false, false, 2);
          break;
        case "2-3":
          setAttribute("2-3", false, true, 2);
          break;
        case "2-5":
          setAttribute("2-5", false, false, 2);
          break;
        case "3-1":
          setAttribute("3-1", false, false, 3);
          break;
        case "3-1-1":
          setAttribute("3-1-1", false, false, 3);
          break;
        case "3-3":
          setAttribute("3-3", true, false, 3);
          break;
        case "3-4":
          setAttribute("3-4", true, false, 3);
          break;
        case "3-4-1":
          setAttribute("3-4-1", true, false, 3);
          break;
        case "3-6":
          setAttribute("3-6", true, false, 2);
          break;
        case "3-7":
          setAttribute("3-7", true, true, 2);
          break;

        case "4-1":
          setAttribute("4-1", true, true, 3);
          break;

        case "4-3":
          setAttribute("4-3", true, false, 3);
          break;
        case "4-4":
          setAttribute("4-4", true, false, 3);
          break;
        case "5-1":
          setAttribute("5-1", true, false, 2);
          break;
        case "5-2":
          setAttribute("5-2", false, false, 2);
          break;
        case "5-3":
          setAttribute("5-3", true, false, 3);
          break;
        case "5-4":
          setAttribute("5-4", true, false, 3);
          break;
        case "5-5":
          setAttribute("5-5", true, false, 3);
          break;
        case "5-6":
          setAttribute("5-6", true, false, 2);
          break;

        case "D-1":
          setAttribute("D-1", true, false, 2);
          break;
        case "D-2":
          setAttribute("D-2", true, false, 2);
          break;
        case "D-3":
          setAttribute("D-3", true, true, 1);
          break;
        case "E-1":
          setAttribute("E-1", false, false, 1);
          break;
        case "E-2":
          setAttribute("E-2", false, false, 1);
          break;
        case "E-3":
          setAttribute("E-3", false, false, 1);
          break;
        case "color-2":
          setAttribute("color-2", true, false, 2);
          break;
        default:
          break;
      }

      //提交
      commit("SET_CARD_TYPE", {
        Card_type,
        hasShopName,
        hasWifi,
        CardQrcodeCount,
      });
    },
  },
  getters: {
    get_CardQrcodeCount: function (state) {
      return state.CardQrcodeCount;
    },
    get_Card_type: function (state) {
      return state.Card_type;
    },
    get_hasShopName: function (state) {
      return state.hasShopName;
    },
    get_hasWifi: function (state) {
      return state.hasWifi;
    },
    get_ossURL: function (state) {
      return state.ossURL;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js